<template>
  <div>
    <div class="progress-tracker">
      <template v-for="(node, index) in nodes">
        <div class="progress-bubble">
          <div :class="{ clickable: node.active }" @click="$emit('stepClicked', index)">
            <img v-show="index === currentStep" src="/images/timeline-node-filled.svg" class="img-fluid" />
            <img v-show="index !== currentStep" src="/images/timeline-node-outline.svg" class="img-fluid" />
            <p class="progress-number" :class="{ active: index === currentStep }">{{ index + 1 }}</p>
          </div>
          <p class="progress-description">{{ node.title }}</p>
        </div>
        <hr v-if="index !== nodes.length - 1" class="progress-line" />
      </template>
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  mounted() {},
})
class ProgressTracker extends Vue {
  @Prop({ type: Array, default: [] })
  nodes;

  @Prop({ type: Number })
  currentStep;
}
export default ProgressTracker;
</script>

<style lang="scss" scoped>
.progress-tracker {
  width: 40rem;
  display: flex;

  @media only screen and (max-width: 990px) {
    width: 100%;
  }

  .progress-bubble {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 98;
    width: 4rem;

    div {
      cursor: default;
    }

    .clickable {
      cursor: pointer;
    }

    p {
      font-weight: bold;
    }
  }

  .progress-number {
    text-align: center;
    font-size: 1.5rem;
    margin-left: 0;
    margin-top: -37px;
    color: black;
    z-index: 99;

    &.active {
      color: #cfe2e8;
    }
  }

  .progress-description {
    color: var(--blue-900);
    text-align: center;
    font-size: 1.25rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .progress-line {
    width: 20%;
    background-color: var(--blue-500);
    margin-left: -1rem;
    margin-right: -1rem;
    z-index: 1;
  }
}
</style>
